import React, {useEffect, useState} from 'react';
import axios from 'axios';

interface Order {
    ID:string,
    ACCOUNT_NUMBER: string,
    DATE_INSERT: string
    CLAIMS_ADD: boolean,
    STATUS_ID: string,
    PRICE: number,
    PICTURE: string[],
}

interface Contragent {
    ID_CONTRAGENT: string,
    NAME_ORGANIZATION: string,
}

interface OrderStatus {
    ID: string,
    NAME: string,
}
function LastOrder(): React.ReactElement|null {

    const ajaxUrl = '/local/templates/Oshisha/components/bitrix/sale.personal.order.list/oshisha_sale.personal.order.list/ajax_for_sort.php';
    const [order, setOrder] = useState<Order>()
    const [contragent, setContragent] = useState<Contragent>()
    const [status, setStatus] = useState<OrderStatus>()
    const [classStatus, setClassStatus] = useState('')

    useEffect(() => {
        axios.post(ajaxUrl, {
                typeSort: 'new',
                limit: 1,
                is_ajax: true,
            }, {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                }
            }
        ).then(response => {
                const curOrder = response.data.listOrders.length > 0 ? response.data.listOrders[0] : null
                setOrder(curOrder)
                if (curOrder) {
                    const curContragent = response.data.contragents.find((contragent: Contragent) => contragent.ID_CONTRAGENT == curOrder.CONTRAGENT_ID)
                    setContragent(curContragent)

                    const curStatus = response.data.listStatuses[curOrder.STATUS_ID] ?? ''
                    setStatus(curStatus)
                }
            }
        )
    }, []);

    useEffect(() => {
        if (order) {
            if (order.STATUS_ID === 'N') {
                setClassStatus('status_pending_payment bg-yellowSt text-black font-medium')
            } else if (order.STATUS_ID === 'P') {
                setClassStatus('status_payment_yes bg-tagFilterGray text-black font-medium')
            } else if (order.STATUS_ID === 'F') {
                setClassStatus('status_completed bg-greenLight dark:bg-greenButton text-white font-normal')
            }
        }
    }, [order]);

    if (!order) {
        return null;
    }

    return (
        <div className="md:px-0 px-5 mb-10">
            <div>
                <p className="md:text-3xl text-xl dark:text-textDarkLightGray text-textLight dark:font-normal flex
                flex-row justify-between font-semibold mb-6">
                    Последний заказ
                </p>
                <div className="flex flex-row flex-wrap">
                    <div className="w-full flex flex-col bg-textDark dark:bg-darkBox md:rounded-3xl rounded-xl xl:p-8 p-5 mx-0 mb-5 sale-order-list-inner-container relative">
                        <div>
                            <h3 className="mb-2 title-orders-his">
                                <p className="mb-3 xl:text-2xl flex md:flex-row flex-col lg:text-lg text-base font-medium
                                text-textLight dark:text-textDarkLightGray md:items-center">
                                    Заказ №{order.ACCOUNT_NUMBER}
                                    <span className="md:text-xs md:ml-3 ml-0 text-10 font-normal text-textLight
                                    dark:text-textDarkLightGray">
                                        от {order.DATE_INSERT}
                                    </span>
                                </p>
                                <div className={"absolute top-0 right-0 xl:py-3 xl:px-5 md:py-2 py-1.5 px-4 " +
                                " md:rounded-bl-3xl md:rounded-tr-3xl md:max-w-[250px] max-w-[200px] md:min-w-[200px] " +
                                " w-full flex items-center justify-center rounded-bl-xl rounded-tr-xl " + classStatus}>
                                    <span className="xl:text-[14px] md:text-xs text-10">{status?.NAME ?? '1'}</span>
                                </div>
                            </h3>
                        </div>
                        <div className="flex flex-row justify-start mb-3 items-center">
                            <div className="sale-order-list-inner mr-3 md:mb-0 md:w-auto w-full md:block flex">
                                <div className="sale-order-list-inner-row-body">
                                    <div className="flex flex-row">
                                        <span className=" mr-2 font-semibold dark:font-medium
                                         text-textLight dark:text-textDarkLightGray xl:text-base md:text-sm text-xs">
                                            Контрагент:
                                        </span>
                                        <span className="font-normal dark:font-medium text-textLight
                                        dark:text-textDarkLightGray xl:text-base md:text-sm text-xs">
                                            {(contragent) ? contragent.NAME_ORGANIZATION : 'Поле не заполнено' }
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="md:my-3 my-1 flex flex-row overflow-auto">
                            {order.PICTURE && order.PICTURE.map((url, index) => (
                                    <img key={index} className="image_box_orders mr-3 rounded-md p-3 bg-white xl:max-w-32 max-w-28
                                    object-container xl:max-h-32 max-h-28"
                                        src={url || '/local/templates/Oshisha/images/no-photo.gif'}
                                        alt="orderImage"
                                    />
                                ))
                            }
                        </div>
                        <div className="col pt-3 wrap-order-l">
                            <div className="sale-order-list-inner-row sale-order-list-inner-row sale-order-list-wrap
                                flex flex-col">
                                <div className={"flex flex-row mb-3 items-center" +
                                    (order.CLAIMS_ADD ? 'justify-between' : 'justify-end')} >
                                    {order.CLAIMS_ADD && (
                                            <div className="buttonOpenClaims mr-3 xl:w-1/3 lg:w-1/3 w-full"
                                                data-order-id={order.ID}
                                                data-order-number={order.ACCOUNT_NUMBER}
                                            ></div>
                                        )}

                                    <div className="sale-order-list-inner mr-3 md:mb-0 mb-3 md:w-auto w-full md:block
                                    flex justify-end">
                                        <div className="sale-order-list-inner-row-body">
                                            <div className="sale-order-list-payment">
                                                <div className="sale-order-list-payment-price flex flex-row">
                                                    <span className="sale-order-list-payment-element mr-2 font-semibold
                                                    dark:font-medium text-textLight dark:text-textDarkLightGray
                                                    xl:text-2xl text-lg">Итого: </span>
                                                    <span className="sale-order-list-payment-number font-semibold
                                                    dark:font-medium text-textLight dark:text-textDarkLightGray
                                                    xl:text-2xl text-lg">
                                                        {Math.round(order.PRICE)} ₽
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="sale-order-list-inner-row flex flex-row">
                                    <div className=" sale-order-list-about-container w-1/2">
                                        <a className="sale-order-list-about-link md:px-5 px-1 xl:py-3 py-2 dark:shadow-md
                                        shadow-shadowDark dark:hover:bg-black cursor-pointer dark:bg-grayButton
                                        rounded-md bg-lightGrayBg flex items-center justify-center w-full"
                                           href={"/personal/orders/" + order.ACCOUNT_NUMBER + "/"}>
                                            <svg className="md:w-7 w-4 md:h-6 h-5" viewBox="0 0 25 26" fill="none"
                                                 xmlns="http://www.w3.org/2000/svg">
                                                <path d="M12.5636 8.51667C13.372 8.51667 14.0272 7.83764 14.0272 7C14.0272 6.16237 13.372 5.48334 12.5636 5.48334C11.7553 5.48334 11.1 6.16237 11.1 7C11.1 7.83764 11.7553 8.51667 12.5636 8.51667Z"
                                                      fill="white"/>
                                                <path d="M12.5636 14.5833C13.372 14.5833 14.0272 13.9043 14.0272 13.0667C14.0272 12.229 13.372 11.55 12.5636 11.55C11.7553 11.55 11.1 12.229 11.1 13.0667C11.1 13.9043 11.7553 14.5833 12.5636 14.5833Z"
                                                      fill="white"/>
                                                <path d="M12.5636 20.65C13.372 20.65 14.0272 19.971 14.0272 19.1334C14.0272 18.2957 13.372 17.6167 12.5636 17.6167C11.7553 17.6167 11.1 18.2957 11.1 19.1334C11.1 19.971 11.7553 20.65 12.5636 20.65Z"
                                                      fill="white"/>
                                            </svg>
                                            <span className="text-white md:text-[15px] text-xs">
                                                Подробности заказа
                                            </span>
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default LastOrder;